<template>
    <div class="p-4">
        <el-card header="Detalhes do pedido">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-row v-if="!order" justify="center" align="middle">
                        <el-col :sm="12" :lg="7">
                            <el-result
                                icon="error"
                                title="Pedido não encontrado"
                                sub-title="O Pedido que procura não foi encontrado, por favor verifique se consta da lista"
                            >
                            </el-result>
                        </el-col>
                    </el-row>
                    <template v-else>
                        <el-form :disabled="updating" :model="order" label-position="top">
                            <el-row :gutter="20">
                                <el-col :sm="24" :md="14" :lg="16">
                                    <el-row :gutter="20">
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Cliente" class="form-control">
                                                <el-icon class="mx-1">
                                                    <UserFilled />
                                                </el-icon>
                                                {{ order.user.name }}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Atribuido a" prop="seller_id" class="form-control">
                                                <el-select :disabled="order.status == 'entregue'" v-model="order.delivery_id">
                                                    <el-option v-for="s in sellers" :label="s.name" :value="s.id" :key="s.id">
                                                        <el-row :gutter="10">
                                                            <el-col :md="12">
                                                                <el-icon>
                                                                    <UserFilled />
                                                                </el-icon>
                                                                {{s.name}}
                                                                <el-icon class="ms-2">
                                                                    <Phone />
                                                                </el-icon>
                                                                {{s.phone}}
                                                            </el-col>
                                                        </el-row>
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Estado do pedido" :class="`form-control border-${status[order.status]}`">
                                                <div :class="`col-auto p-0 px-2 rounded text-light fw-bold bg-${status[order.status]} bg-gradient`">
                                                    {{ order.status }}
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Solicitado em" class="form-control">
                                                {{ new Date(order.created_at ?? '').toLocaleString() }}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Contacto cliente" class="form-control">
                                                <el-icon class="mx-1">
                                                    <Phone />
                                                </el-icon> {{ order.phone }}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8" v-if="order.status != 'pendente'">
                                            <el-form-item label="Atualizado em" class="form-control">
                                                {{ new Date(order.updated_at ?? '').toLocaleString() }}
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="Total geral:" class="form-control">
                                                <label class="text-success fw-bold">
                                                    {{ order.total_price.toFixed(2).replace('.', ',') }} MT
                                                </label>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="12" :lg="8">
                                            <el-form-item label="" class="">
                                            </el-form-item>
                                        </el-col>

                                        <ElCol :cols="24" v-if="['pendente'].includes(order.status)" class="px-4">
                                            <ElRow :gutter="20">
                                                <el-form-item label="">
                                                    <el-button :loading="updating" @click="submit" plain type="warning">
                                                        Alterar entregador
                                                    </el-button>
                                                </el-form-item>

                                                <el-form-item label="" class="mx-2">
                                                    <el-button :loading="updating" @click="cancel" plain type="danger">
                                                        Canelar pedido
                                                    </el-button>
                                                </el-form-item>
                                            </ElRow>
                                        </ElCol>
                                    </el-row>
                                </el-col>
                                <el-col :sm="24" :md="10" :lg="8">
                                    <el-form-item>
                                        <template #label>
                                            <el-icon>
                                                <MapLocation />
                                            </el-icon>
                                            {{order.area?.name}}
                                        </template>
                                        <div class="col-12 position-relative" style="height: 450px">
                                            <l-map ref="map" :zoom="16" :center="[order.area?.lat ?? 0, order.area?.long ?? 0]">
                                                <l-tile-layer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    layer-type="base"
                                                    name="OpenStreetMap"
                                                ></l-tile-layer>
    
                                                <l-marker :lat-lng="[order.area?.lat ?? 0, order.area?.long ?? 0]" :draggable="false">
                                                    <l-tooltip>Local da entrega</l-tooltip>
                                                </l-marker>
                                            </l-map>
                                            <a target="_blank" :href="`https:\/\/www.google.com/\maps?q=${order.area?.lat},${order.area?.long}`" class="btn btn-warning">Abrir no google maps</a>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>

                        <el-col :sm="24">
                            <el-collapse accordion class="my-4">
                                <el-collapse-item name="1" title="Produtos do pedido">
                                    <template  v-for="storeOrder in order.store_orders" :key="storeOrder.store_id">
                                        <h6>Da loja <RouterLink :to="`/admin/store/${storeOrder.store.id}`">
                                            {{ storeOrder.store.name }}
                                        </RouterLink></h6>

                                        <ProductsList @click-open="openProduct" :items="storeOrder.items.map(item => ({
                                            icon: 'View', 
                                            id: Number(item.product.id), 
                                            image: '', 
                                            title: item.product.name,
                                            subtitle: `${item.quant} unidades x ${item.unit_price.toFixed(2).replace('.', ',')}MT \n = ${(item.quant * item.unit_price).toFixed(2).replace('.', ',')} MT`
                                        }))">
                                        </ProductsList>
                                    </template>
                                </el-collapse-item>
                            </el-collapse>
                        </el-col>
                    </template>
                </template>
            </el-skeleton>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Product, User } from "@/services/types";
    import { ElMessage, ElMessageBox } from "element-plus";
    import { computed, onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { Order } from "@/services/types/order";
import ProductsList from "@/components/ProductsList.vue";
import { url } from "node:inspector";

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params

    const loading = ref<boolean>(true)
    const updating = ref<boolean>(false)
        
        const status = reactive<{
        'pendente': string
        'andamento': string
        'entregue': string
        'preparo': string
    }>({
        'pendente': 'danger',
        'andamento': 'warning',
        'preparo': 'primary',
        'entregue': 'success'
    })
    
    const order = ref<Order>()
    const sellers = ref<Array<User>>([])
    const products = computed(() => order.value?.store_orders.flatMap(o => o.items) ?? [])
    
    const getOrder = async () => {
        updating.value = true
        const res = await Api.get('admin/orders/' + id)
        if (res.status == 200) {
            const data = res.data.order
            order.value = data
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        updating.value = false
    }

    onBeforeMount(async () => {
        loading.value = true
        // get sellers
        const res = await Api.get('admin/sellers')
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ao buscar os entregadores ' + res.data.message})
            return
        }
        sellers.value = res.data.sellers
        await getOrder()

        loading.value = false
    })

    const submit = async () => {
            updating.value = true
            const res = await Api.put(`admin/orders/${id}?delivery_id=${order.value?.delivery_id}`, {})
            console.log(res.data)

            if (res.status == 200) {
                ElMessage.success({message: 'Entregador Actualizado com sucesso'})
                // location.reload()
                await getOrder()
            } else if (res.status == 422) {
                if (res.data.errors) {
                    for(let err in res.data.errors) {
                        ElMessage.error({message: res.data.errors[err].join(', ')})
                    }
                }
            } else {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            }
            updating.value = false
           
    }

    const cancel = async () => {
        if (confirm("Deseja realmente cancelar este pedido?\n\nEsta acção é irreversível")) {
            updating.value = true
            const res = await Api.delete(`admin/orders/${id}`)
            if (res.status == 200) {
                ElMessageBox.alert("Pedido cancelado e eliminado").then(() => {
                    router.replace('/dashboard')
                })
            } else {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            }
            updating.value = true

        }
    }

    const openProduct = (id: number | string) => {
        router.push('/products/' + id)
    }
</script>
